/**
 * A message the user has to notice.
 *
 * `role="alert"` on the failure variant so a screen reader announces it
 * without the user having to go looking for what went wrong.
 */

import type { ReactNode } from 'react'

export function Alert({ tone, children }: { tone: 'error' | 'info'; children: ReactNode }) {
  return (
    <p className={`alert alert--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      {children}
    </p>
  )
}
